import { Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";

import { CommonModule } from "@angular/common";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NgScrollbarModule } from "ngx-scrollbar";
import {
  API_URLS,
  DATEFORMATE,
  DATE_FORMAT_WITH_TIME,
  SCROLLBARS_OPTIONS,
  TIME_FORMATE,
} from "../../../config/app.constants";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../shared/utils";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  standalone: true,
  imports: [
    RouterLink,
    NgbTooltip,
    NgbTooltip,
    NgScrollbarModule,
    CommonModule,
  ],
})
export class DashboardComponent implements OnInit {
  dashboardCounter: any;
  scrollPageNumber: number = 1;
  totalPageLength: number = 0;
  recentOrders: any[] = [];
  recentPayments: any[] = [];
  petMedication: any[] = [];
  notificationFeeds: any[] = [];
  isScrollDone: boolean = false;
  isNotificationLoading: boolean = false;

  format: string = DATEFORMATE;
  timeFormat = TIME_FORMATE;
  formatWithTime: string = DATE_FORMAT_WITH_TIME;
  scrollbarOptions = Object.assign({}, SCROLLBARS_OPTIONS);

  constructor(private http: HttpinterceptorService, private router: Router) {
    let _this = this;
    this.scrollbarOptions["callbacks"] = {
      whileScrolling: function () {
        if (this.mcs.topPct == 90 && !_this.isScrollDone) {
          _this.onScrollDown();
          _this.isScrollDone = true;
        } else {
          _this.isScrollDone = false;
        }
      },
    };
  }

  ngOnInit() {
    this.getDashboardCounter();
    this.getMedicationDetails();
    this.getRecentOrders();
    this.getRecentPayments();
    this.getRecentNotifications(1);
  }

  getDashboardCounter() {
    this.http
      .post(API_URLS.GET_USER_DASHBOARD_COUNT, {}, false)
      .subscribe((response) => {
        if (response.data) {
          this.dashboardCounter = response.data;
        }
      });
  }

  getMedicationDetails() {
    this.http
      .post(API_URLS.GET_ACTIVE_BOOKING_MEDICATION, {}, false)
      .subscribe((response) => {
        if (response.data) {
          this.petMedication = response.data;
        }
      });
  }

  getRecentOrders() {
    this.http
      .post(API_URLS.GET_RECENT_ORDERS, {}, false)
      .subscribe((response) => {
        if (response.data) {
          this.recentOrders = response.data;
        }
      });
  }

  getRecentPayments() {
    this.http
      .post(API_URLS.GET_RECENT_PAYMENTS, {}, false)
      .subscribe((response) => {
        if (response.data) {
          this.recentPayments = response.data;
        }
      });
  }

  getRecentNotifications(pageNumber) {
    this.isNotificationLoading = true;
    this.http
      .post(
        API_URLS.GET_ALL_NOTIFICATIONS,
        {
          draw: pageNumber,
          length: 10,
        },
        false
      )
      .subscribe((response) => {
        if (response.data.current_page === 1)
          this.totalPageLength = response.data.last_page;
        this.addNotifications(response.data.data);
        this.isNotificationLoading = false;
      });
  }

  addNotifications(notifications) {
    for (let index in notifications) {
      if (notifications.hasOwnProperty(index)) {
        notifications[index]["notificationTime"] = Utils.getDateDifference(
          notifications[index].created_at
        );
        this.notificationFeeds.push(notifications[index]);
      }
    }
  }

  onScrollDown() {
    if (this.totalPageLength > this.scrollPageNumber)
      this.getRecentNotifications((this.scrollPageNumber += 1));
  }

  // viewOrderDetails(orderType, orderId) {
  //   const type = orderType == 'booking' ? 'booking' : 'subscription';
  //   this.router.navigate(['/orders', type, orderId]);
  // }

  viewOrderDetails(serviceType, order) {
    let link = [];
    let uniqueId = order.unique_id ? order.unique_id : order.id;
    switch (serviceType) {
      case "subscription":
        if (order.is_new_subscription) {
          link = ["subscription/new/detail", uniqueId];
        } else {
          link = ["subscription/detail", uniqueId];
        }
        break;
      case "booking":
        link = ["booking/detail", uniqueId, "order"];
        break;
      case "grooming":
        link = ["grooming/details", uniqueId, "order"];
        break;
      case "product":
        link = ["product/purchased/detail", uniqueId];
        break;
      default:
        break;
    }
    this.router.navigate(link);
  }

  viewRecentPaymentDetail(referenceType, payment) {
    let link = [];
    let uniqueId;
    switch (referenceType) {
      case "subscription":
      case "subscription schedule":
        uniqueId = payment.subscription_unique_id
          ? payment.subscription_unique_id
          : payment.subscription_id;
        if (payment.is_new_subscription) {
          link = ["subscription/new/detail", uniqueId];
        } else {
          link = ["subscription/detail", uniqueId];
        }
        break;
      case "booking":
        uniqueId = payment.cage_booking_unique_id
          ? payment.cage_booking_unique_id
          : payment.booking_id;
        link = ["booking/detail", uniqueId, "order"];
        break;
      case "grooming":
        uniqueId = payment.grooming_unique_id
          ? payment.grooming_unique_id
          : payment.reference_id;
        link = ["grooming/details", uniqueId, "order"];
        break;
      case "product":
        uniqueId = payment.product_unique_id
          ? payment.product_unique_id
          : payment.reference_id;
        link = ["product/purchased/detail", uniqueId];
        break;
      default:
        break;
    }
    this.router.navigate(link);
  }
}
